import { ReportIssueState } from '@quizzach/interfaces';
import { consoleDev, ConsoleStatus, fetchData } from '@quizzach/utils';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useReportIssue = () => {
	const [error, setError] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);
	const [state, setState] = useState<
		ReportIssueState.submitting | ReportIssueState.submitted
	>(ReportIssueState.submitting);
	const path = useLocation();

	const reportIssue = async ({
		issueText,
		issueReason,
		question_uuid,
	}: {
		issueText: string;
		issueReason: string;
		question_uuid: string;
	}) => {
		setLoading(true);

		try {
			const response = await fetchData<any>(
				`/api/questions/problem-report`,
				{
					method: 'POST',
					body: JSON.stringify({
						text: issueText,
						problem_type: issueReason,
						question_uuid: question_uuid,
					}),
				},
				{
					authRoute: true,
				}
			);
			if (response.status >= 300) {
				consoleDev('reportIssue', ConsoleStatus.HTTP, response.status);
				setError(true);
			} else {
				consoleDev('reportIssue', ConsoleStatus.SUCC);
			}
		} catch (err) {
			consoleDev('reportIssue', ConsoleStatus.NET, err);
			setError(true);
		} finally {
			setLoading(false);
			setState(ReportIssueState.submitted);
		}
	};

	useEffect(() => {
		setState(ReportIssueState.submitting);
	}, [path]);

	return { error, loading, state, reportIssue };
};
